import React from "react";
import logo from "./logo.svg";
import "bootstrap/dist/css/bootstrap.css";
import "./theme/App.scss";
import "./theme/all.min.css";
import PublicRoutes from "./routes/PublicRoutes";

function App() {
  return (
    <>
      <PublicRoutes />
    </>
  );
}

export default App;
